import React from 'react';
import { connect } from 'react-redux';
import TextBlockFooterContainer from './text-block-footer-container';
import { setTextBlockFooterTitle, setTextBlockFooterText } from '../../../../state/actions/landing-page-editor';

const TextBlockFooterRedux = (props) => (
  <TextBlockFooterContainer {...props} />
);

const mapStateToProps = (state, ownProps) => {
  const { entityId:id } = ownProps;
  const { editor } = state.landingPages.landingPage;
  const currentEntity = editor[id] || {};
  const tbf = currentEntity.textBlockFooter || { title: '', text: '' };
  return {
    title: tbf.title,
    text: tbf.text,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { entityId:id } = ownProps;
  return {
    onTitleChange: (val) => dispatch(setTextBlockFooterTitle(id, val)),
    onTextChange: (val) => dispatch(setTextBlockFooterText(id, val)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextBlockFooterRedux);


